<template>
  <div class="app-shell flex h-screen overflow-hidden max-md:flex-col">
    <AppSidebar @logout="logout" />

    <main class="app-shell-main min-w-0 flex-1 overflow-y-auto">
      <header class="app-shell-topbar flex items-center justify-end">
        <AppButton small aria-label="Sök kund" @click="openUserSearch">
          <template #prepend>
            <SvgIcon :path="mdiMagnify" :size="18" />
          </template>
          Sök
        </AppButton>
      </header>

      <div class="app-shell-content">
        <div v-if="title || $slots.actions" class="mb-4 flex flex-wrap items-baseline justify-between gap-2">
          <h1 v-if="title">{{ title }}</h1>
          <slot name="actions" />
        </div>

        <slot />
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { mdiMagnify } from '@mdi/js'
import { AppButton, SvgIcon, useModal } from '@staff/ui'
import AppSidebar from '@/components/AppSidebar.vue'
import UserSearchModal from '@/views/users/components/UserSearchModal.vue'
import { clearToken } from '@/services/auth'

defineProps<{
  // Optional title, some views render their own page heading (e.g. /bolan)
  title?: string
}>()

const router = useRouter()
const { openModal } = useModal()

const logout = async () => {
  clearToken()
  await router.push('/login')
}

const openUserSearch = () => {
  openModal('Sök kund', UserSearchModal, {})
}
</script>

<style scoped>
.app-shell {
  background-color: var(--color-canvas-inset);
}

.app-shell-main {
  padding: 0 24px 24px;
  scrollbar-gutter: stable;
}

.app-shell-topbar {
  padding-top: 16px;
}

/* Cap content width so it does not stretch on wide/ultrawide screens (the sidebar
   stays pinned left; this caps only the content column). ~1440px lets a 13" laptop
   use the full width and only caps larger screens. */
.app-shell-content {
  max-width: 1440px;
  margin-inline: auto;
  padding-top: 12px;
}

@media (max-width: 767px) {
  .app-shell-main {
    padding: 0 16px 16px;
  }

  .app-shell-topbar {
    padding-top: 12px;
  }

  .app-shell-content {
    padding-top: 8px;
  }
}
</style>
